import React from "react";

const LOGO_SRC =
  "https://customer-assets.emergentagent.com/job_assembler-showcase/artifacts/w52bh8fv_Logo%20sem%20Fundo.png";

/**
 * Official original blue artwork in both themes, without color filters.
 *
 * @param {string} size - tailwind size classes (e.g. "h-11 w-11")
 * @param {string} className - extra wrapper classes
 */
export const BrandLogo = ({ size = "h-11 w-11", className = "" }) => (
  <span
    aria-hidden="true"
    className={`relative inline-flex items-center justify-center shrink-0 ${size} ${className}`}
  >
    <img
      src={LOGO_SRC}
      alt=""
      className="brand-mark"
      loading="eager"
      decoding="async"
    />
  </span>
);

export default BrandLogo;
